import {ModuleWithProviders, NgModule, Type} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DomainDetailComponent} from './components/domain-detail/domain-detail.component';
import {DomainService} from './services/domain.service';
import {ContactInfoEditComponent} from './components/domain-detail/contact-info/contact-info-edit/contact-info-edit.component';
import {NameServersViewComponent} from './components/domain-detail/name-servers/name-servers-view/name-servers-view.component';
import {ContactInfoViewComponent} from './components/domain-detail/contact-info/contact-info-view/contact-info-view.component';
import {FinalizeRequestViewComponent} from './components/domain-detail/finalize-request-view/finalize-request-view.component';
import {SubmitConfirmationComponent} from './components/create-request/submit-confirmation/submit-confirmation.component';
import {NameserversEditComponent} from './components/domain-detail/name-servers/name-servers-edit/name-servers-edit.component';
import {ReviewChangesComponent} from './components/create-request/review-changes/review-changes.component';
import {NameServersComponent} from './components/domain-detail/name-servers/name-servers.component';
import {ContactInfoComponent} from './components/domain-detail/contact-info/contact-info.component';
import {SubDomainInfoComponent} from './components/domain-detail/sub-domain-info/sub-domain-info.component';
import {SubDomainInfoViewComponent} from './components/domain-detail/sub-domain-info/sub-domain-info-view/sub-domain-info-view.component';
import {SubDomainInfoEditComponent} from './components/domain-detail/sub-domain-info/sub-domain-info-edit/sub-domain-info-edit.component';
import {TrustAnchorsComponent} from './components/domain-detail/trust-anchors/trust-anchors.component';
import {TrustAnchorsValidatorsService} from './validators/service/trust-anchors-validators.service';
import {RdapServersValidatorService} from './validators/service/rdap-servers-validator.service';
import {ValidatorService} from './services/validator.service';
import {NameServersValidatorDirective} from './validators/name-servers-validator.directive';
import {HostNameValidatorDirective} from './validators/host-name-validator.directive';
import {CreateRequestComponent} from './components/create-request/create-request.component';
import {SponsoringOrgComponent} from './components/domain-detail/sponsoring-org/sponsoring-org.component';
import {SponsoringOrgViewComponent} from './components/domain-detail/sponsoring-org/sponsoring-org-view/sponsoring-org-view.component';
import {SponsoringOrgEditComponent} from './components/domain-detail/sponsoring-org/sponsoring-org-edit/sponsoring-org-edit.component';
import {CommonNewDelegationComponent} from './components/new-delegation/common-new-delegation.component';
import {DomainTypeComponent} from './components/new-delegation/domain-type/domain-type.component';
import {SummaryOfChangesComponent} from './components/create-request/summary-of-changes/summary-of-changes.component';
import {LastChangePipe} from './pipes/last-change.pipe';
import {CheckNullPipe} from './pipes/check-null.pipe';
import {CheckNullAndReturnValuePipe} from './pipes/check-null-and-return-value.pipe';
import {ValueFromAdditionalMapPipe} from './pipes/value-from-additional-map.pipe';
import {TrustAnchorValueExtractorPipe} from './pipes/trust-anchor-value-extractor.pipe';
import {TechCheckCssHelperPipe} from './components/tech-check-request-details/pipe/tech-check-css-helper.pipe';
import {TechCheckRequestDetailsComponent} from './components/tech-check-request-details/tech-check-request-details.component';
import {TechCheckResultComponent} from './components/tech-check-request-details/tech-check-result/tech-check-result.component';
import {TechCheckLogComponent} from './components/tech-check-request-details/tech-check-log/tech-check-log.component';
import {CommonDomainRoutingModule} from './common-domain-routing.module';
import {ChangesRequestedBlockComponent} from './components/request-details/changes-requested-block/changes-requested-block.component';
import {AuthorizersListBlockComponent} from './components/request-details/authorizers-list-block/authorizers-list-block.component';
// tslint:disable-next-line:max-line-length
import {
  ChangeRequestHeaderBlockComponent
} from './components/request-details/change-request-header-block/change-request-header-block.component';
import {NgxSmartModalModule} from 'ngx-smart-modal';
import {UserSettingsComponent} from './components/user-management/user-settings/user-settings.component';
import {ChangePasswordComponent} from './components/user-management/change-password/change-password.component';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {WorkflowMappingHelperPipe} from './pipes/workflow-mapping-helper.pipe';
import {CookieService} from 'ngx-cookie-service';
import {DomainsListViewComponent} from './components/domain-management/domains-list-view/domains-list-view.component';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {MetaDataComponent} from './components/domain-detail/meta-data/meta-data.component';
import {MetaDataViewComponent} from './components/domain-detail/meta-data/meta-data-view/meta-data-view.component';
import {MetaDataEditComponent} from './components/domain-detail/meta-data/meta-data-edit/meta-data-edit.component';
import {
  AuditLogIndividualSectionComponent
} from './components/audit-log/audit-log-individual-section/audit-log-individual-section.component';
import {AuditLogTitleHelperPipe} from './components/audit-log/helper/audit-log-title-helper.pipe';
import {AuditLogComponent} from './components/domain-detail/audit-log/audit-log.component';
import {AuditLogFilterPipe} from './components/audit-log/helper/audit-log-filter.pipe';
import {AuditLogBlockComponent} from './components/audit-log/audit-log-block/audit-log-block.component';
import {DomainListHelperPipe} from './components/domain-management/domains-list-view/helper/domain-list-helper.pipe';
import {UserAuditLogComponent} from './components/user-management/user-audit-log/user-audit-log.component';
import {CommonAlertsComponent} from './components/common-alerts/common-alerts.component';
import {DisplayValueFromChangePipe} from './pipes/display-value-from-change.pipe';
import {DefineDomainViewCssPipe} from './pipes/define-domain-view-css.pipe';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PendingRequestIdExtractorPipe} from './pipes/pending-request-id-extractor.pipe';
import {ViewDomainComponent} from './components/view-domain/view-domain.component';
import {MetadataHelperPipe} from './components/domain-detail/meta-data/metadata-helper.pipe';
import {SortIpUtilPipe} from './components/domain-detail/name-servers/sort-ip-util.pipe';
import {ErrorPageComponent} from './components/error-page/error-page.component';
import {ImpactedPartiesTldListComponent} from './components/request-details/impacted-parties-tld-list/impacted-parties-tld-list.component';
import {AuthPolicyViewComponent} from './components/domain-detail/auth-policy-screen/auth-policy-view/auth-policy-view.component';
import {AuthPolicyEditComponent} from './components/domain-detail/auth-policy-screen/auth-policy-edit/auth-policy-edit.component';
import {AuthPolicyHelperPipe} from './components/domain-detail/auth-policy-screen/auth-policy-view/auth-policy-helper.pipe';
import {AuthPolicyEditHelperPipe} from './components/domain-detail/auth-policy-screen/auth-policy-edit/auth-policy-edit-helper.pipe';
import {
  AuthPolicyAddUserModalComponent
} from './components/domain-detail/auth-policy-screen/auth-policy-add-user-modal/auth-policy-add-user-modal.component';
import {AuthPolicyScreenComponent} from './components/domain-detail/auth-policy-screen/auth-policy-screen.component';
import {PolicyCssHelperPipe} from './components/domain-detail/auth-policy-screen/auth-policy-edit/policy-css-helper.pipe';
import {CommonSmartModalComponent} from './components/common-smart-modal/common-smart-modal.component';
import {ModalCssHelperPipe} from './components/common-smart-modal/modal-css-helper.pipe';
import {UserProfileComponent} from './components/user-management/user-profile/user-profile.component';
import {UserProfileViewComponent} from './components/user-management/user-profile/user-profile-view/user-profile-view.component';
import {UserProfileEditComponent} from './components/user-management/user-profile/user-profile-edit/user-profile-edit.component';
import {OpenChangeRequestsComponent} from './components/domain-detail/open-change-requests/open-change-requests.component';
import {RzmHeaderComponent} from './components/rzm-header/rzm-header.component';
import {RzmFooterComponent} from './components/rzm-footer/rzm-footer.component';
import {NavigationBarComponent} from './components/navigation-bar/navigation-bar.component';
import {DateValidatorDirective} from './validators/date-validator.directive';
import {EmailValidatorDirective} from './validators/email-validator.directive';
import {UrlValidatorDirective} from './validators/url-validator.directive';
import {RequiredFieldValidatorDirective} from './validators/required-field-validator.directive';
import {AsciiValidatorDirective} from './validators/ascii-validator.directive';
import {PasswordStrengthValidatorDirective} from './validators/password-strength-validator.directive';
import {DomainNameConverterPipe} from './pipes/domain-name-converter.pipe';
import {ValidCharacterValidatorDirective} from './validators/valid-character-validator.directive';
import {CommonDatePipe} from './pipes/common-date.pipe';
import {UtilService} from './util/util.service';
import { UsersListBlockComponent } from './components/request-details/users-list-block/users-list-block.component';
import { UserInviteActionComponent } from './components/request-details/user-invite-action/user-invite-action.component';
import {
  DsRecordsEditComponent
} from './components/domain-detail/trust-anchors/ds-records-edit/ds-records-edit.component';
import {
  DsRecordsViewComponent
} from './components/domain-detail/trust-anchors/ds-records-view/ds-records-view.component';
import {
  WhitelistCharacterErrorComponent
} from "./components/whitelist-character-error/whitelist-character-error.component";
import { UserLinkComponent } from './components/user-link/user-link.component';
import { TwoFactorAuthenticationComponent } from './components/user-management/two-factor-authentication/two-factor-authentication.component';
import {QRCodeModule} from "angularx-qrcode";
import { ApiTokensComponent } from './components/user-management/api-tokens/api-tokens.component';
import {
  PasswordStrengthMeterService
} from "./services/password-strength-meter.service";
import {PasswordStrengthMeterComponent} from "./components/password-strength-meter/password-strength-meter.component";
import {PSMProgressBarDirective} from "./components/password-strength-meter/psm-progress-bar.directive";
import {
    IdVerificationSettingsComponent
} from "./components/user-management/id-verification-settings/id-verification-settings.component";
import {FlatpickrDirective} from "angularx-flatpickr";

type PSMOptions = {
  serviceClass: Type<PasswordStrengthMeterService>;
};

const defaultOptions: PSMOptions = {
  serviceClass: PasswordStrengthMeterService,
};


@NgModule({
  declarations: [
    DomainDetailComponent,
    ReviewChangesComponent,
    NameServersViewComponent,
    ContactInfoViewComponent,
    FinalizeRequestViewComponent,
    SubmitConfirmationComponent,
    ContactInfoEditComponent,
    NameserversEditComponent,
    NameServersComponent,
    ContactInfoComponent,
    SubDomainInfoComponent,
    SubDomainInfoViewComponent,
    SubDomainInfoEditComponent,
    TrustAnchorsComponent,
    DsRecordsViewComponent,
    DsRecordsEditComponent,
    NameServersValidatorDirective,
    HostNameValidatorDirective,
    CreateRequestComponent,
    SponsoringOrgComponent,
    SponsoringOrgViewComponent,
    SponsoringOrgEditComponent,
    CommonNewDelegationComponent,
    DomainTypeComponent,
    SummaryOfChangesComponent,
    LastChangePipe,
    CheckNullPipe,
    CheckNullAndReturnValuePipe,
    ValueFromAdditionalMapPipe,
    TrustAnchorValueExtractorPipe,
    TechCheckCssHelperPipe,
    TechCheckRequestDetailsComponent,
    TechCheckResultComponent,
    TechCheckLogComponent,
    ChangesRequestedBlockComponent,
    AuthorizersListBlockComponent,
    ChangeRequestHeaderBlockComponent,
    UserSettingsComponent,
    ChangePasswordComponent,
    WorkflowMappingHelperPipe,
    DomainsListViewComponent,
    MetaDataComponent,
    MetaDataViewComponent,
    MetaDataEditComponent,
    AuditLogIndividualSectionComponent,
    AuditLogTitleHelperPipe,
    AuditLogComponent,
    AuditLogFilterPipe,
    AuditLogBlockComponent,
    DomainListHelperPipe,
    UserAuditLogComponent,
    CommonAlertsComponent,
    DisplayValueFromChangePipe,
    DefineDomainViewCssPipe,
    PendingRequestIdExtractorPipe,
    ViewDomainComponent,
    MetadataHelperPipe,
    SortIpUtilPipe,
    ErrorPageComponent,
    ImpactedPartiesTldListComponent,
    AuthPolicyScreenComponent,
    AuthPolicyViewComponent,
    AuthPolicyEditComponent,
    AuthPolicyHelperPipe,
    AuthPolicyEditHelperPipe,
    AuthPolicyAddUserModalComponent,
    PolicyCssHelperPipe,
    CommonSmartModalComponent,
    ModalCssHelperPipe,
    UserProfileComponent,
    UserProfileViewComponent,
    UserProfileEditComponent,
    OpenChangeRequestsComponent,
    UserInviteActionComponent,
    DsRecordsEditComponent,
    DsRecordsViewComponent,

    RzmHeaderComponent,
    RzmFooterComponent,
    NavigationBarComponent,

    DateValidatorDirective,
    EmailValidatorDirective,
    UrlValidatorDirective,
    RequiredFieldValidatorDirective,
    AsciiValidatorDirective,
    PasswordStrengthValidatorDirective,
    DomainNameConverterPipe,
    ValidCharacterValidatorDirective,
    CommonDatePipe,
    UsersListBlockComponent,
    WhitelistCharacterErrorComponent,
    UserLinkComponent,
    TwoFactorAuthenticationComponent,
    IdVerificationSettingsComponent,
    ApiTokensComponent,
    PasswordStrengthMeterComponent,
    PSMProgressBarDirective,
  ],
  exports: [
    CommonNewDelegationComponent,
    CreateRequestComponent,
    TechCheckRequestDetailsComponent,
    SummaryOfChangesComponent,
    TechCheckLogComponent,
    CommonSmartModalComponent,
    CommonDomainRoutingModule,
    ChangesRequestedBlockComponent,
    AuthorizersListBlockComponent,
    ChangeRequestHeaderBlockComponent,
    WorkflowMappingHelperPipe,
    DomainsListViewComponent,
    AuditLogIndividualSectionComponent,
    CommonAlertsComponent,
    AuditLogBlockComponent,
    ReviewChangesComponent,
    SubmitConfirmationComponent,
    ViewDomainComponent,
    ErrorPageComponent,
    ChangePasswordComponent,
    ImpactedPartiesTldListComponent,
    UserSettingsComponent,
    UserProfileComponent,
    UserProfileViewComponent,
    UserProfileEditComponent,
    UsersListBlockComponent,
    UserInviteActionComponent,

    RzmHeaderComponent,
    RzmFooterComponent,
    WhitelistCharacterErrorComponent,

    DomainNameConverterPipe,
    ValidCharacterValidatorDirective,
    RequiredFieldValidatorDirective,
    AsciiValidatorDirective,
    CommonDatePipe,
    PasswordStrengthMeterComponent,
    PSMProgressBarDirective,
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxUiLoaderModule,
        InfiniteScrollDirective,
        NgxSmartModalModule.forRoot(),
        FontAwesomeModule,
        QRCodeModule,
        FlatpickrDirective
    ],
  providers: [
    UtilService,
    DomainService,
    CookieService,
    ValidatorService,
    TrustAnchorsValidatorsService,
    RdapServersValidatorService,
  ]
})
export class CommonDomainModule {
  static configure(env): ModuleWithProviders<CommonDomainModule> {
    return {
      ngModule: CommonDomainModule,
      providers: [{provide: 'env', useValue: env}]
    };
  }
}
